// SPDX-License-Identifier: SEE LICENSE
import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';

export function Layout({
  children,
  connected,
  right,
  hideHeader,
}: {
  children: ReactNode;
  connected?: boolean;
  right?: ReactNode;
  hideHeader?: boolean;
}) {
  return (
    <div
      className="min-h-screen w-full"
      style={{
        background:
          'radial-gradient(1100px 460px at 28% -12%, rgba(20,222,205,0.06), transparent 60%), #04090f',
        color: '#cfe0e0',
        fontSize: 13,
        overflowX: 'hidden',
      }}
    >
      {!hideHeader && <header
        className="sticky top-0 z-20 backdrop-blur"
        style={{
          background: 'rgba(4,9,15,0.82)',
          borderBottom: '1px solid rgba(120,160,160,0.12)',
        }}
      >
        <div
          className="flex items-center justify-between"
          style={{ height: 54, padding: '0 22px' }}
        >
          <Link to="/" className="flex items-center" style={{ gap: 12, textDecoration: 'none' }}>
            <img
              src="/retronics-logo.jpeg"
              alt="Retronics"
              style={{
                width: 32,
                height: 32,
                borderRadius: 8,
                objectFit: 'contain',
                background: 'rgba(20,222,205,0.07)',
                border: '1px solid rgba(20,222,205,0.4)',
                boxShadow: '0 0 18px -4px rgba(20,222,205,0.6)',
              }}
            />
            <span
              style={{
                fontSize: 15,
                fontWeight: 600,
                letterSpacing: 3,
                color: '#e8f2f1',
              }}
            >
              LIVE DIAGNOSTIC ENGINE
            </span>
          </Link>
          <div className="flex items-center" style={{ gap: 12 }}>
            {connected !== undefined && (
              <span
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 7,
                  fontSize: 11,
                  letterSpacing: 1.5,
                  color: connected ? '#34d399' : '#6f878e',
                  fontWeight: 600,
                }}
              >
                <span
                  style={{
                    width: 7,
                    height: 7,
                    borderRadius: '50%',
                    background: connected ? '#34d399' : '#6f878e',
                    boxShadow: connected ? '0 0 8px #34d399' : 'none',
                  }}
                  className={connected ? 'animate-livepulse' : ''}
                />
                {connected ? 'LIVE' : 'OFFLINE'}
              </span>
            )}
            {right}
          </div>
        </div>
      </header>}
      <main
        className="w-full"
        style={{
          boxSizing: 'border-box',
          padding: hideHeader
            ? 'clamp(8px, 1vw, 11px)'
            : 'clamp(12px, 1.4vw, 18px) clamp(14px, 1.6vw, 22px) clamp(16px, 1.8vw, 24px)',
        }}
      >
        {children}
      </main>
    </div>
  );
}
